import jquery from 'jquery/dist/jquery.js';
export default (window.$ = window.jQuery = jquery);
